export const ADMIN = 'admin';
export const MODERATOR = 'moderator';
export const CONTRIBUTOR = 'contributor';
export const VIEWER = 'viewer';
export const PARTICIPANT = 'participant'; // accounts only

export const spaceRoles = [ ADMIN, MODERATOR, CONTRIBUTOR, VIEWER ];
export const accountRoles = [ ADMIN, MODERATOR, CONTRIBUTOR, PARTICIPANT ];
